<template>
  <div class="link-youtube">
    <div
      v-if="!form[field.key] || !form[field.key].length"
      class="text-primary"
    >
      Chưa có link youtube
    </div>
    <el-row
v-else
class="list-link mt-l"
:gutter="16">
      <el-col
        v-for="(l, index) in form[field.key]"
        :key="index"
        :lg="4"
        :md="6"
        :sm="8"
        :span="12"
        class="mt-m"
      >
        <el-button
          v-if="!disabled"
          type="danger"
          class="remove-link"
          circle
          size="mini"
          @click="handleRemoveLink(l)"
        >
          <i class="el-icon-close" />
        </el-button>
        <iframe
:src="l"
frameborder="0"
height="150px"
width="100%" />
      </el-col>
    </el-row>
    <el-input
      v-if="!disabled"
      v-model="link"
      class="w-50"
      placeholder="Nhập link youtube"
      @keyup.native.enter="handleAddLink"
    >
      <el-button
slot="append"
@click="handleAddLink">
        <i class="el-icon-plus" />
      </el-button>
    </el-input>
  </div>
</template>

<script>
import patterns from "@/config/patterns";
export default {
  name: "Youtube",
  props: {
    form: Object,
    field: Object,
    disabled: Boolean,
  },
  data() {
    return {
      link: "",
    };
  },
  methods: {
    handleAddLink() {
      if (this.link) {
        const regExp = patterns.YOUTUBE_LINK;
        if (this.link.match(regExp)) {
          if ((this.form[this.field.key] || []).find((l) => l === this.link)) {
            this.$notify.warning({
              title: "Thông báo",
              message: "Link youtube đã tồn tại.",
            });
          } else {
            let link = this.link.split("&")[0];
            if (this.link.includes("watch?v=")) {
              link = this.link.replace("watch?v=", "embed/").split("&")[0];
            } else if (this.link.includes("/shorts/")) {
              link = this.link.replace("/shorts/", "/embed/").split("&")[0];
            }
            this.form[this.field.key].push(link);
            this.link = "";
          }
        } else {
          this.$notify.warning({
            title: "Thông báo",
            message: "Link youtube không đúng định dạng.",
          });
        }
      } else {
        this.$notify.warning({
          title: "Thông báo",
          message: "Chưa nhập link youtube.",
        });
      }
    },

    handleRemoveLink(link) {
      this.form[this.field.key] = this.form[this.field.key].filter(
        (l) => l !== link
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.link-youtube {
  .list-link {
    .el-col {
      position: relative;
      .remove-link {
        position: absolute;
        right: 0%;
        top: -5%;
      }
    }
  }
}
</style>
